import { eAccountType } from 'types/order/escrow/IAchAccountData';
import { IACHDisbursementFormData } from 'types/order/escrow/achDisbursements/IACHDisbursementFormData';
import { ICheckDisbursementFormData } from 'types/order/escrow/checks/ICheckDisbursementFormData';
import { eDisbursementType } from 'types/order/escrow/eDisbursementType';
import { IInternalTransferDisbursementFormData } from 'types/order/escrow/internalTransferDisbursements/IInternalTransferDisbursementFormData';
import { IWireDisbursementFormData } from 'types/order/escrow/wires/IWireDisbursementFormData';
import { ICreateSettlementFeeForm } from 'types/order/fees/ICreateSettlementItemForm';
import { v4 } from 'uuid';
import { defaultCreate } from '../defaultCreate';
import { IOrderDetailsData } from '../../../../../../ui-toolkit/orders/interfaces/IOrderDetailsData';

export const ACHConversions = {
  Check: (
    checkData: ICheckDisbursementFormData,
    order: IOrderDetailsData,
    isSpruceWithZillowEnabled: boolean,
    isZillowClosing: boolean
  ): IACHDisbursementFormData => {
    const { amountCents, statementFeeId, holdback, holdbackProperties } = checkData;
    const fileNumber = order.transaction.file_number ?? '';
    const wellsFargoTransactionNumber = isZillowClosing ? fileNumber.substring(0, 11) : fileNumber.substring(6);
    return {
      type: eDisbursementType.ACH,
      id: v4(),
      isNew: true,
      category: undefined,
      statementFeeId,
      amountCents,
      wellsFargoTransactionNumber,
      holdback,
      holdbackProperties,
    };
  },
  'Internal Transfer': (
    internalTransfer: IInternalTransferDisbursementFormData,
    order: IOrderDetailsData,
    fee: ICreateSettlementFeeForm,
    isSpruceWithZillowEnabled: boolean,
    isZillowClosing: boolean
  ): IACHDisbursementFormData => {
    const { amountCents, statementFeeId, holdback, holdbackProperties } = internalTransfer;
    const fileNumber = order.transaction.file_number ?? '';
    const wellsFargoTransactionNumber = isZillowClosing ? fileNumber.substring(0, 11) : fileNumber.substring(6);
    const { beneficiary } = defaultCreate(fee, order, isSpruceWithZillowEnabled, isZillowClosing);
    return {
      type: eDisbursementType.ACH,
      id: v4(),
      isNew: true,
      category: undefined,
      statementFeeId,
      amountCents,
      wellsFargoTransactionNumber,
      holdback,
      holdbackProperties,
      account: {
        name: beneficiary ?? '',
        routingNumber: '',
        accountNumber: '',
        accountNumberConfirmation: '',
        accountType: '' as eAccountType,
      },
    };
  },
  Wire: (
    wireData: IWireDisbursementFormData,
    order: IOrderDetailsData,
    isSpruceWithZillowEnabled: boolean,
    isZillowClosing: boolean
  ): IACHDisbursementFormData => {
    const {
      amountCents,
      beneficiary,
      routingNumber = '',
      accountNumber = '',
      accountNumberConfirmation = '',
      statementFeeId,
      holdback,
      holdbackProperties,
    } = wireData;
    const fileNumber = order.transaction.file_number ?? '';
    const wellsFargoTransactionNumber = isZillowClosing ? fileNumber.substring(0, 11) : fileNumber.substring(6);
    return {
      type: eDisbursementType.ACH,
      id: v4(),
      isNew: true,
      amountCents,
      account: {
        name: beneficiary ?? '',
        routingNumber,
        accountNumber,
        accountNumberConfirmation,
        accountType: '' as eAccountType,
      },
      statementFeeId,
      wellsFargoTransactionNumber,
      holdback,
      holdbackProperties,
    };
  },
};
